<template>
  <BaseShareSentiment
    :title="title"
    :item-id="itemId"
    :operation="operation"
    :field="field"
    :group="group"
    :entity="entity"
    :label="label"
    :polarity="polarity"
    :hide-null="hideNull"
    :filter-name="filterName"
    :stack-labels="stackLabels"
    v-bind="$attrs"
  />
</template>

<script>
import BaseShareSentiment from '@/components/cards/BaseShareSentiment';
import { OPERATION, ENTITIES } from '@/services/charts-service';
import proprietaryModel from '@/mixins/proprietary-model';

export default {
  name: 'PropBaseShareSentiment',
  components: {
    BaseShareSentiment,
  },
  mixins: [
    proprietaryModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    operation: {
      type: String,
      default: OPERATION.COUNT,
    },
    field: {
      type: String,
      default: null,
    },
    group: {
      type: String,
      required: true,
    },
    entity: {
      type: String,
      default: ENTITIES.POSTS,
    },
    label: {
      type: String,
      default: null,
    },
    polarity: {
      type: Boolean,
      default: true,
    },
    hideNull: {
      type: Boolean,
      default: false,
    },
    stackLabels: {
      type: [Boolean, String],
      default: true,
    },
    filterName: {
      type: String,
      default: null,
    },
  },
};
</script>
